module.exports = __webpack_public_path__ + "static/media/Fontfabric - MullerHeavy.4ff456da.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/Fontfabric - MullerHeavy.otf
// module id = 1066
// module chunks = 0